import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaceKeywordsPipeModule } from 'projects/common/pipes/replace-keywords.module';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { AlertsBannerComponent } from './alerts-banner.component';
import { EvaMessageModule } from "../eva-message/eva-message.module";
import { EmptyStateModule } from '../empty-state/empty-state.module';
import { AlertsModule } from '@shopping-angular-components/alerts';
import { PriceAlertsService } from 'projects/common/services/price-alerts.service';
import { AlertsSacModalComponent } from './alerts-sac-modal.component';
import { TextBannerModule } from '../text-banner/text-banner.module';


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        EvaButtonModule,
        ReplaceKeywordsPipeModule,
        TextBannerModule,
        EmptyStateModule,
        AlertsModule
    ],
    exports: [
      AlertsBannerComponent,
      AlertsSacModalComponent
    ],
    declarations: [
      AlertsBannerComponent,
      AlertsSacModalComponent
    ],
    providers: [
      PriceAlertsService
    ]
})
export class PriceAlertsModule { }
